export class CreateTaskCommentInputDto {
    text: string;
    taskId: string;
}
